import React, { useState } from 'react';
import axios from 'axios';
import { Card } from '../../../../design-system';
import Alert from '../../../../helpers/alert';
import { successRefetch } from '../../../../helpers/data-loader';
import ModalForm from '../../../../components/ModalForm';
import {
  Table,
  TableCardHeader,
  TableBody as TableBodyBase,
} from '../../../../components/Table';
import { ERR_MSG } from '../../../../globalConstants';
import { OUTCOMES_COLUMNS, OUTCOMES_MODAL_FIELDS } from './constants';

const TableBody = TableBodyBase as React.ComponentType<any>;

interface OutcomesProps {
  data: any;
  clientId: any;
  refetch: () => void;
  canEdit: boolean;
}

const Outcomes = ({ data, clientId, refetch, canEdit }: OutcomesProps) => {
  const [targetedOutcome, setTargetedOutcome] = useState<any>('');
  const [isOpenAddOutcome, setIsOpenAddOutcome] = useState(false);
  const [isOpenEditOutcome, setIsOpenEditOutcome] = useState(false);

  const toggleAddOutcome = () => {
    setIsOpenAddOutcome(!isOpenAddOutcome);
  };

  const toggleEditOutcome = () => {
    setIsOpenEditOutcome(!isOpenEditOutcome);
  };

  const openEditModal = async (values) => {
    setTargetedOutcome(values);
    toggleEditOutcome();
  };

  const handleOutcomeCreate = async (values) => {
    try {
      await axios.post(`/client/${clientId}/case/${data.id}/outcomes`, values);
      setIsOpenAddOutcome(false);
      successRefetch(refetch);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };

  const handleOutcomeEdit = async (values) => {
    try {
      await axios.put(
        `/client/${clientId}/case/${data.id}/outcomes/${values.id}`,
        values,
      );
      setIsOpenEditOutcome(false);
      successRefetch(refetch);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };

  const handleDeleteOutcome = async (id) => {
    try {
      await axios.delete(`/client/${clientId}/case/${data.id}/outcomes/${id}`);
      successRefetch(refetch);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };
  return (
    <Card mt={20}>
      <TableCardHeader
        name="Outcomes"
        action="Add Outcome"
        onClick={toggleAddOutcome}
        disabled={!canEdit}
      />
      <TableBody maxHeight="15rem">
        <Table
          data={data.case_outcomes.map((item) => ({
            ...item,
            handleDeleteOutcome,
            openEditModal,
            canEdit,
          }))}
          columns={OUTCOMES_COLUMNS}
        />
      </TableBody>
      <ModalForm
        title="Add Outcome"
        isOpen={isOpenAddOutcome}
        onSubmit={handleOutcomeCreate}
        onClose={toggleAddOutcome}
        fields={OUTCOMES_MODAL_FIELDS}
        oneColumn
      />
      <ModalForm
        title="Edit Outcome"
        isOpen={isOpenEditOutcome}
        onSubmit={handleOutcomeEdit}
        onClose={toggleEditOutcome}
        fields={OUTCOMES_MODAL_FIELDS}
        oneColumn
        initialValues={targetedOutcome}
      />
    </Card>
  );
};

export default Outcomes;
